import React from "react";

import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import ConfirmDialog from "./ConfirmDialog";

// Delete-specific confirmation dialog, built on top of the generic ConfirmDialog
// (e.g. "Delete Employee", "Delete Selected Employees", "Delete Ticket").
function DeleteDialog({
  open,
  onClose,
  onConfirm,
  title = "Delete",
  message = "Are you sure you want to delete this?",
  itemName,
  extra,
  isDeleting = false,
  confirmLabel = "Delete"
}) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      itemName={itemName}
      note="This action cannot be undone."
      extra={extra}
      isLoading={isDeleting}
      confirmLabel={confirmLabel}
      loadingLabel="Deleting..."
      confirmColor="error"
      confirmIcon={<DeleteSweepIcon />}
    />
  );
}

export default DeleteDialog;
